var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 18.25C6.125 17.5625 6.6875 17 7.375 17C8.0625 17 8.625 17.5625 8.625 18.25C8.625 18.9375 8.0625 19.5 7.375 19.5C6.6875 19.5 6.125 18.9375 6.125 18.25ZM12.375 17H17.375C18.0625 17 18.625 17.5625 18.625 18.25C18.625 18.9375 18.0625 19.5 17.375 19.5H12.375C11.6875 19.5 11.125 18.9375 11.125 18.25C11.125 17.5625 11.6875 17 12.375 17ZM19.875 23.25H4.875C4.18625 23.25 3.625 22.6888 3.625 22V14.5H21.125V22C21.125 22.6888 20.5638 23.25 19.875 23.25M4.875 5.75H6.125V7C6.125 7.6875 6.6875 8.25 7.375 8.25C8.0625 8.25 8.625 7.6875 8.625 7V5.75H16.125V7C16.125 7.6875 16.6875 8.25 17.375 8.25C18.0625 8.25 18.625 7.6875 18.625 7V5.75H19.875C20.5638 5.75 21.125 6.31125 21.125 7V12H3.625V7C3.625 6.31125 4.18625 5.75 4.875 5.75M19.875 3.25H18.625V2C18.625 1.3125 18.0625 0.75 17.375 0.75C16.6875 0.75 16.125 1.3125 16.125 2V3.25H8.625V2C8.625 1.3125 8.0625 0.75 7.375 0.75C6.6875 0.75 6.125 1.3125 6.125 2V3.25H4.875C2.8075 3.25 1.125 4.9325 1.125 7V22C1.125 24.0675 2.8075 25.75 4.875 25.75H19.875C21.9425 25.75 23.625 24.0675 23.625 22V7C23.625 4.9325 21.9425 3.25 19.875 3.25",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.9b5818590b2eecb025b78971d9c19628.svg";
export { ForwardRef as ReactComponent };